import DataAccess from '@/Services/DataAccess.js'
import VueJwtDecode from 'vue-jwt-decode'

const state = {
  user: {
    token: null,
    expiration: null,
    userName: null,
    userId: null,
    userEmail: null,
    familyName: null,
    role: null
  }
}

const mutations = {
  SET_USER_DATA (state, userData) {
    // console.log('USERDATA TOKEN: ', userData.token)
    state.user.token = userData.token
    // console.log('USERDATA EXPIRATION: ', userData.expiration)
    state.user.expiration = userData.expiration
    this.decoded = VueJwtDecode.decode(userData.token)
    // console.log('DECODED: ', this.decoded)

    // console.log('userdata: ', this.decoded.unique_name)
    state.user.userName = this.decoded.unique_name

    // console.log('userid: ', this.decoded.nameid)
    state.user.userId = this.decoded.nameid

    // console.log('email: ', this.decoded.email)
    state.user.userEmail = this.decoded.email

    // console.log('family_name: ', this.decoded.family_name)
    state.user.familyName = this.decoded.family_name

    // console.log('role: ', this.decoded.role)
    state.user.role = this.decoded.role

    // Arxiva en en local storage les variable
    localStorage.setItem('user', JSON.stringify(state.user))

    // Especifica en la capçalera de la petició el JWT
    DataAccess.apiClient.defaults.headers.common.Authorization = `Bearer ${state.user.token}`
    // console.log('ARRIBEM AL TOKEN BEARER TOKEN in:' + userData.token)
  },

  CLEAR_USER_DATA () {
    // state.user= null
    localStorage.removeItem('user')
    // axios.defaults.headers.common['Authorization'] = null
    location.reload()
  }
}

const actions = {
  async modifPassword ({ commit, dispatch }, credentials) {
    return DataAccess
      .putData('/api/usuarios/UpdateUserPassword', credentials)
      .then(({ data }) => {
        commit('SET_USER_DATA', data)
        // const notification = {
        //   type: 'success',
        //   messageTitle: 'Cambio en el perfil de usuario',
        //   messageDetail: 'Nuevo password.'
        // }
        // dispatch('notification/add', notification, { root: true })
      })
      .catch(error => {
        // const notification = {
        //   type: 'error',
        //   messageTitle: 'Error Perfil de Usuario',
        //   messageDetail: 'Accion: Cambio Password: ' + error.response.data.Error
        // }
        // dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  async modifProfile ({ commit }, credentials) {
    (async () => {
      await DataAccess.postData('/api/usuarios/UpdateUserProfile', credentials)
        .then(() => {
          // const notification = {
          //   type: 'success',
          //   messageTitle: 'Registro de Usuario',
          //   messageDetail: 'Registro Correcto: '
          // }
          // dispatch('notification/add', notification, { root: true })
          console.log('SUCCESS')
          // console.log(response.data)
        })
        .catch(error => {
          // const notification = {
          //   type: 'error',
          //   messageTitle: 'Error en la Registro del Usuario',
          //   messageDetail: 'Accion: Register: ' + error.response.data.Error
          // }
          // dispatch('notification/add', notification, { root: true })
          throw error
        })
    })()
  },

  // registerRole(credentials){
  //   return axios
  //   .post('https://localhost:44379/api/roles/AsignarUsuarioRol',{
  //     'UserId': credentials.id,
  //     'RoleName': credentials.RoleName
  //   })
  // },
  async register ({ dispatch }, credentials) {
    (async () => {
      await DataAccess.postData('/api/usuarios/Crear', credentials)
        .then(() => {
          // const notification = {
          //   type: 'success',
          //   messageTitle: 'Registro de Usuario',
          //   messageDetail: 'Registro Correcto: '
          // }
          // dispatch('notification/add', notification, { root: true })
          console.log('SUCCESS')
          // console.log(response.data)
        })
        .catch(error => {
          // const notification = {
          //   type: 'error',
          //   messageTitle: 'Error en la Registro del Usuario',
          //   messageDetail: 'Accion: Register: ' + error.response.data.Error
          // }
          // dispatch('notification/add', notification, { root: true })
          throw error
        })
    })()
  },

  async login ({ commit, dispatch, state }, credentials) {
    (async () => {
      await DataAccess.postData('/api/usuarios/Login', credentials)
        .then(response => {
          commit('SET_USER_DATA', response.data)
          // console.log('SUCCESS')
          // console.log(response.data)
        })
        .catch(error => {
          console.log('DELETE ERROR: ', error)
        })
    })()
  },
  logout ({ commit, dispatch }) {
    commit('CLEAR_USER_DATA')
    // NETEJA LES DADES COMPLEMTARIES DEL VUEX RELATIVES A POWERBI
  }
}

const getters = {
  loggedIn (state) {
    return !!state.user.userName
  },
  loggedUserAccount (state) {
    return state.user.userEmail
  },
  loggedUserName (state) {
    return state.user.familyName
  },
  loggedUserID (state) {
    return state.user.userId
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
